<h1 mat-dialog-title>Observaciones</h1>
<div>
  <mat-tab-group>
    <mat-tab *ngIf="!onlyAuditoriaObservationReadOnly" label="Observaciones internas">
      <form [formGroup]="orderObservationForm" (ngSubmit)="saveOrderObservation()">
        <mat-form-field appearance="standard" class="full-control">
          <mat-label>Observaciones</mat-label>
          <textarea formControlName="OrderObservation" matInput required></textarea>
          <button mat-mini-fab matSuffix type="submit" matTooltip="Agregar observación"> <mat-icon>add</mat-icon></button>
          <mat-error *ngIf="f.OrderObservation.errors && f.OrderObservation.errors.required">
            Agregue la observación
          </mat-error>
        </mat-form-field>
      </form>
      <div class="observation-table-scroll">
        <table class="table-content">
          <tr>
            <th class="cell-date">Fecha</th>
            <th class="cell-date">Usuario</th>
            <th>Observaciones</th>
          </tr>

          <tr *ngFor="let obs of orderObservations">
            <td class="cell-date">{{obs.CreateDate}}</td>
            <td class="cell-date">{{obs.CreateUserName}}</td>
            <td><div style="width:100%; max-width:400px; word-wrap: break-word">{{obs.Observation}} </div></td>
          </tr>
        </table>
      </div>
    </mat-tab>
    <mat-tab *ngIf="!onlyAuditoriaObservationReadOnly" label="Observaciones paciente">
      <div class="observation-table-scroll">
        <table class="table-content">
          <tr>
            <th class="cell-date">Fecha</th>
            <th class="cell-date">Usuario</th>
            <th>Observaciones</th>
          </tr>

          <tr *ngFor="let obs of patientObservations">
            <td class="cell-date">{{obs.CreateDate}}</td>
            <td class="cell-date">{{obs.CreateUserName}}</td>
            <td><div style="width:100%; max-width:400px; word-wrap: break-word">{{obs.Observation}} </div></td>
          </tr>
        </table>
      </div>
    </mat-tab>

    <mat-tab label="Observaciones auditoría">
      <form *ngIf="!onlyAuditoriaObservationReadOnly" [formGroup]="auditoriaObservationForm" (ngSubmit)="saveAuditoriaObservation()">
        <mat-form-field appearance="standard" class="full-control">
          <mat-label>Observaciones</mat-label>
          <textarea formControlName="AuditoriaObservation" matInput required></textarea>
          <button mat-mini-fab matSuffix type="submit" matTooltip="Agregar observación"> <mat-icon>add</mat-icon></button>
          <mat-error *ngIf="faud.AuditoriaObservation.errors && faud.AuditoriaObservation.errors.required">
            Agregue la observación
          </mat-error>
        </mat-form-field>
      </form>
      <div class="observation-table-scroll">
        <table class="table-content">
          <tr>
            <th class="cell-date">Fecha</th>
            <th class="cell-date">Usuario</th>
            <th>Observaciones</th>
          </tr>

          <tr *ngFor="let obs of auditoriaObservations">
            <td class="cell-date">{{obs.CreateDate}}</td>
            <td class="cell-date">{{obs.CreateUserName}}</td>
            <td><div style="width:100%; max-width:400px; word-wrap: break-word">{{obs.Observation}} </div></td>
          </tr>
        </table>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
  </div>
</div>
